import { render } from "./TopNavigationBar.vue?vue&type=template&id=c2b7eca4"
import script from "./TopNavigationBar.vue?vue&type=script&lang=js"
export * from "./TopNavigationBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__